export default __webpack_public_path__ + "static/media/export_image_2.86ea6e16.jpg";